import React from 'react';

import GreenCheckList from '../GreenCheckList';

const ColorCard = ({ title, text, color, items }) => {
  return (
    <div className={`ColorCard ${color}`}>
      <div className="ColorCard__title">{title}</div>
      <p className="ColorCard__text">{text}</p>
      {items && <GreenCheckList items={items} />}
    </div>
  );
};

export default ColorCard;
